// extracted by mini-css-extract-plugin
module.exports = {"main":"Main-module--main--2QJXN"};